var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"stroke-2 inline-block",class:{
    'h-3 w-3': _vm.size === 'sm',
    'h-4 w-4': _vm.size === 'base',
    'h-5 w-5': _vm.size === 'lg',
  },attrs:{"data-test-id":("icon_" + _vm.name),"fill":"none","stroke":"currentColor","viewBox":"0 0 24 24","stroke-linecap":"round","stroke-linejoin":"round","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{domProps:{"innerHTML":_vm._s(_vm.icons[_vm.name])}})])}
var staticRenderFns = []

export { render, staticRenderFns }